<template>
    <div>
        <east-operate>
            <template #left>
                <el-button-group>
                    <el-button
                        size="mini"
                        type="danger"
                        icon="el-icon-switch-button"
                        @click="cancelTerminals"
                        >注销</el-button
                    >
                    <el-button
                        size="mini"
                        type="success"
                        icon="el-icon-success"
                        @click="updateState(true)"
                        >启用</el-button
                    >
                    <el-button
                        size="mini"
                        type="warning"
                        icon="el-icon-remove"
                        @click="updateState(false)"
                        >停用</el-button
                    >
                </el-button-group>
            </template>
            <template #right>
                <el-input
                    placeholder="请输入姓名/账号"
                    style="width:200px"
                    size="mini"
                    v-model.trim="filterKeyword"
                    clearable
                >
                    <el-button
                        type="primary"
                        icon="el-icon-search"
                        size="mini"
                        title="搜索用户"
                        @click="filterData"
                        slot="append"
                    >
                    </el-button>
                </el-input>
            </template>
        </east-operate>
        <el-table
            ref="authTable"
            :data="tableData"
            tooltip-effect="dark"
            :empty-text="emptyText"
            v-loading="loading"
            :height="tableHeight"
            @selection-change="handleSelectionChange"
            :row-class-name="tableRowClassName"
        >
            >
            <el-table-column
                type="selection"
                width="50"
                align="center"
                fixed="left"
                :selectable="selectable"
            ></el-table-column>
            <el-table-column prop="name" label="用户/分组" width="300">
                <template slot-scope="scope">
                    <div @click="switchChildren(scope.row)" :style="scope.row.style">
                        <i
                            v-if="scope.row.hasChildren && scope.row.account !== self"
                            :class="[
                                scope.row.hideChildren
                                    ? 'el-icon-arrow-right'
                                    : 'el-icon-arrow-down'
                            ]"
                        ></i>
                    </div>
                    <el-avatar
                        v-if="scope.row.type === 0"
                        :style="{ 'background-color': '#0c86f8' }"
                        :src="scope.row.image === '' ? '' : staticURL + scope.row.image"
                    >
                        {{ scope.row.name.charAt(0).toUpperCase() }}
                    </el-avatar>
                    <el-avatar
                        v-else
                        :style="{ 'background-color': '#ffa806', 'font-weight': 'normal' }"
                    >
                        {组}
                    </el-avatar>
                    {{ scope.row.name }}
                </template>
            </el-table-column>
            <el-table-column prop="summary" label="描述" show-overflow-tooltip>
                <template slot-scope="scope">
                    <div v-if="scope.row.type === 0">
                        账号: {{ scope.row.account }}&nbsp;&nbsp;手机:
                        {{ scope.row.phone }} &nbsp;&nbsp;邮箱:
                        {{ scope.row.email }}
                    </div>
                    <div else>
                        {{ scope.row.summary }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="isEnable" label="状态" width="100" align="center">
                <template slot-scope="scope">
                    <el-switch
                        v-if="scope.row.type === 0"
                        v-model="scope.row.isEnable"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        :width="30"
                        @change="
                            handleSelectionChange([scope.row])
                            updateState(scope.row.isEnable)
                        "
                        :disabled="scope.row.account === self"
                        title="启用/停用"
                    >
                    </el-switch>
                    <el-switch v-if="scope.row.type === 1" :width="30" :disabled="false">
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="300" fixed="right">
                <template slot-scope="scope">
                    <el-button
                        title="添加用户"
                        icon="el-icon-circle-plus-outline"
                        size="mini"
                        @click="handleAddUser(scope.row)"
                        >用户</el-button
                    >
                    <el-button
                        title="添加分组"
                        icon="el-icon-circle-plus-outline"
                        size="mini"
                        @click="handleAddGroup(scope.row)"
                        >分组</el-button
                    >
                    <el-button
                        type="primary"
                        icon="el-icon-edit"
                        size="mini"
                        @click="handleEdit(scope.row)"
                    >
                    </el-button>
                    <el-button
                        :disabled="disabled(scope.row)"
                        type="danger"
                        icon="el-icon-delete"
                        size="mini"
                        @click="handleDelete(scope.row)"
                    >
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 添加修改区 开始 -->
        <east-user v-if="userShow" :userData="userData" @hide="hideUser" @refresh="fetchData">
        </east-user>
        <east-group v-if="groupShow" :groupData="groupData" @hide="hideGroup" @refresh="fetchData">
        </east-group>
        <!-- 添加修改区 结束 -->
    </div>
</template>
<script>
import EastOperate from '../../../../components/east-operate'
import EastGroup from './group'
import EastUser from './user'
import config from '../../../../api/config'
import { getAuths, deleteAuths } from '../../../../api/main/api-auths'
import { upState, deleteTerminals } from '../../../../api/main/api-user'
export default {
    data() {
        return {
            staticURL: config.staticURL,
            tableHeight: window.innerHeight - 150,
            tableData: [],
            filterKeyword: '',
            emptyText: ' ',
            loading: true,
            groupData: {
                id: 0,
                pid: 0,
                name: '',
                summary: '',
                value: ''
            },
            groupShow: false,
            userData: {
                id: 0,
                pid: 0,
                account: '',
                password: '',
                name: '',
                phone: '',
                email: '',
                value: '',
                isEnable: true,
                image: '',
                eSign: ''
            },
            userShow: false,
            self: this.$store.getters.account,
            multipleSelection: []
        }
    },
    components: {
        'east-operate': EastOperate,
        'east-group': EastGroup,
        'east-user': EastUser
    },
    created() {
        this.fetchData()
    },
    mounted() {
        window.addEventListener('resize', () => this.measure(), false)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.measure(), false)
    },
    methods: {
        tableRowClassName({ row, rowIndex }) {
            let className = ''
            if (row.type === 1) {
                className = 'group-row'
            }
            if (row.hidden) {
                className = className === '' ? 'row-hide' : className + ' row-hide'
            }
            return className
        },
        measure() {
            this.tableHeight = window.innerHeight - 150
        },
        // 获取数据列表
        fetchData() {
            let tempData = this.tableData
            getAuths().then(res => {
                this.loading = false
                if (res.code === 0) {
                    res.data.forEach(row => {
                        let tempRow = tempData.find(it => it.id === row.id && it.tree === row.tree)
                        if (tempRow) {
                            row.hideChildren = tempRow.hideChildren
                            row.hidden = tempRow.hidden
                        } else {
                            row.hideChildren = true
                            row.hidden = row.depth > 1
                        }
                        row.style = {
                            'margin-left': (row.depth - 1) * 20 + 'px',
                            display: 'inline-block',
                            width: '20px',
                            height: '20px',
                            'line-height': '20px',
                            'text-align': 'center',
                            cursor: 'pointer'
                        }
                    })
                    this.tableData = res.data
                } else {
                    this.emptyText = res.msg
                }
            })
        },
        filterData() {
            if (this.filterKeyword !== '') {
                this.tableData = this.tableData.filter(
                    item =>
                        (item.account + '').toLowerCase() === this.filterKeyword.toLowerCase() ||
                        (item.name + '').indexOf(this.filterKeyword) !== -1
                )
                this.tableData.forEach(item => {
                    item.hidden = false
                    item.hasChildren = false
                    item.depth = 0
                    item.style = {
                        display: 'none'
                    }
                })
            } else {
                this.fetchData()
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val
        },
        selectable(row) {
            return row.account !== this.self && row.type === 0
        },
        disabled(row) {
            return row.hasChildren || row.pid === 0 || row.account === this.self
        },
        switchChildren(row) {
            row.hideChildren = !row.hideChildren
            if (row.hideChildren) {
                // 隐藏所有子节点
                this.tableData
                    .filter(p => p.tree.includes(row.tree) && p.tree !== row.tree)
                    .forEach(row => {
                        row.hidden = true
                        row.hideChildren = true
                    })
            } else {
                // 显示一级节点
                this.tableData
                    .filter(p => p.pid === row.id)
                    .forEach(row => {
                        row.hidden = false
                    })
            }
        },
        handleAddGroup(row) {
            // 添加分组
            this.groupData.id = 0
            this.groupData.pid = row.id
            this.groupData.name = ''
            this.groupData.summary = ''
            this.groupData.value = ''
            this.groupShow = true
        },
        handleAddUser(row) {
            this.userData.id = 0
            this.userData.pid = row.id
            this.userData.account = ''
            this.userData.password = ''
            this.userData.name = ''
            this.userData.phone = ''
            this.userData.email = ''
            this.userData.value = ''
            this.userData.isEnable = true
            this.userData.image = ''
            this.userData.eSign = ''
            this.userShow = true
        },
        handleEdit(row) {
            if (row.type === 0) {
                this.userData.id = row.id
                this.userData.pid = row.pid
                this.userData.account = row.account
                this.userData.name = row.name
                this.userData.phone = row.phone
                this.userData.email = row.email
                this.userData.isEnable = row.isEnable
                this.userData.image = row.image === '' ? '' : this.staticURL + row.image
                this.userData.eSign = row.eSign === '' ? '' : this.staticURL + row.eSign
                this.userShow = true
            } else {
                this.groupData.id = row.id
                this.groupData.pid = row.pid
                this.groupData.name = row.name
                this.groupData.summary = row.summary
                this.groupShow = true
            }
        },
        hideGroup() {
            this.groupShow = false
        },
        hideUser() {
            this.userShow = false
        },
        updateState(enable) {
            if (this.multipleSelection.length === 0) {
                this.$message.warning({
                    message: `请选择要${enable ? '启用' : '停用'}的用户`,
                    duration: 2000
                })
            } else {
                console.log(this.multipleSelection.map(it => it.account))
                upState({
                    enable: enable,
                    accounts: this.multipleSelection.map(it => it.account)
                }).then(res => {
                    if (res.code === 0) {
                        this.$message({
                            type: enable ? 'success' : 'info',
                            message: res.msg
                        })
                        this.multipleSelection.forEach(function(i, index) {
                            i.isEnable = enable
                        })
                        this.$refs.authTable.clearSelection()
                    } else {
                        this.$message.error(res.msg)
                    }
                })
            }
        },
        cancelTerminals() {
            if (this.multipleSelection.length === 0) {
                this.$message.warning({
                    message: '请选择要注销终端的用户',
                    duration: 2000
                })
            } else {
                this.$confirm('此操作将强制注销所选账户的全部登录终端, 确认?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    lockScroll: false
                })
                    .then(() => {
                        deleteTerminals(this.multipleSelection.map(it => it.account)).then(res => {
                            if (res.code === 0) {
                                this.$message.success(res.msg)
                                this.$refs.authTable.clearSelection()
                            } else {
                                this.$message.error(res.msg)
                            }
                        })
                    })
                    .catch(() => {
                        this.$refs.authTable.clearSelection()
                    })
            }
        },
        handleDelete(row) {
            this.$confirm('删除不可恢复,确认?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                lockScroll: false
            })
                .then(() => {
                    deleteAuths(row.id).then(res => {
                        if (res.code === 0) {
                            this.fetchData()
                            this.$notify.success({
                                title: '成功',
                                message: `${row.type === 0 ? '用户' : '分组'}删除成功`,
                                duration: 1500
                            })
                        } else {
                            this.$notify.error({
                                title: '失败',
                                message: `${row.type === 0 ? '用户' : '分组'}删除失败`,
                                duration: 1500
                            })
                        }
                    })
                })
                .catch(() => {})
        }
    }
}
</script>
<style lang="less">
.el-table__row {
    font-size: 13px;
}
.group-row td {
    font-weight: bold;
}
tr.row-hide {
    display: none;
}
.el-avatar {
    width: 22px;
    height: 22px;
    line-height: 22px;
    vertical-align: middle;
    color: #ffffff;
    font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/pages/main/security/auth/auth.vue